// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.body[data-v-42d9642b] {\n  /* background-color: #f3f6f9; */\n  background-image: url(\"/media/bg/bg-login.png\");\n  background-size: cover;\n  background-color: #f5f5f9;\n}\n", ""]);
// Exports
module.exports = exports;
